// extracted by mini-css-extract-plugin
export var copiedNotification = "ShareButton-module--copiedNotification--5714d";
export var copiedNotificationLeft = "ShareButton-module--copiedNotificationLeft--bfeb9";
export var copiedNotificationRight = "ShareButton-module--copiedNotificationRight--ef9d1";
export var cyan = "ShareButton-module--cyan--282ad";
export var linkIcon = "ShareButton-module--linkIcon--b3da6";
export var red = "ShareButton-module--red--6253b";
export var root = "ShareButton-module--root--7d30a";